import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsIssueFieldsManagementRoute } from '@atlassian/jira-router-routes-admin-pages-fields-routes/src/globalSettingsIssueFieldsManagementRoute.tsx';
import { globalSettingsIssueFieldsManagementRouteEntryPoint } from '@atlassian/jira-admin-pages-fields-page/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';

const globalSettingsIssueFieldsManagementEntryPointPage = createPageEntryPoint({
	main: globalSettingsIssueFieldsManagementRouteEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const globalSettingsIssueFieldsManagementRouteEntry = createEntry(
	globalSettingsIssueFieldsManagementRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.fields',
		component: ErrorPagesNotFound,
		layout: globalSettingsLayout,
		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},
		canTransitionIn: () => fg('centralized-fields-page-m1'),
		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],
		entryPoint() {
			if (fg('centralized-fields-page-m1')) {
				return globalSettingsIssueFieldsManagementEntryPointPage;
			}
		},
	}),
);
